var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { ContentBox, ContentBoxHead, ContentBoxBody, ContentCollapser, TeleScript, isHash, TableDesktop, TableMobile, stripTags, formatDate, } from '../../../index';
import headingPlainText from '../../utils/headingPlainText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { getCollectionRewardFromGamePlay } from '../../utils/collectionRewardUtils';
// TODO: Convert file to tsx
var MyCollectionsHistory = function (_a) {
    var _b, _c, _d;
    var collection = _a.collection, actions = _a.actions, _e = _a.telescript, telescript = _e === void 0 ? {} : _e, _f = _a.options, options = _f === void 0 ? {
        variant: 'theme-primary',
        hasCollapser: true,
        hash: 'collections-history',
        pageSize: 10,
        promotionsLink: '/promotions',
        upArrow: _jsx(FontAwesomeIcon, { icon: faChevronUp }),
        downArrow: _jsx(FontAwesomeIcon, { icon: faChevronDown }),
    } : _f;
    var _g = useState(false), pageLoaded = _g[0], setPageLoaded = _g[1];
    var _h = useState(1), page = _h[0], setPage = _h[1];
    var pageSize = (_b = options === null || options === void 0 ? void 0 : options.pageSize) !== null && _b !== void 0 ? _b : 5;
    var hash = (_c = options === null || options === void 0 ? void 0 : options.hash) !== null && _c !== void 0 ? _c : 'collections-history';
    useEffect(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!pageLoaded) return [3 /*break*/, 2];
                            return [4 /*yield*/, actions.collectionActions.getCollections({ page: page, pagesize: pageSize })];
                        case 1:
                            _a.sent();
                            setPageLoaded(true);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        fetchData();
        // Reset state on unmount.
        return function () {
            setPage(1);
            setPageLoaded(false);
        };
    }, []);
    var collections = collection.collections, total = collection.total;
    var loadMoreData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, actions.collectionActions.getCollections({ page: page + 1, pagesize: pageSize })];
                case 1:
                    _a.sent();
                    setPage(page + 1);
                    return [2 /*return*/];
            }
        });
    }); };
    // if there are more collections, show the link for more
    var loadMoreLink = function () {
        return (collections === null || collections === void 0 ? void 0 : collections.length) > 0 && (collections === null || collections === void 0 ? void 0 : collections.length) < total ? (_jsx("div", { className: 'text-center my-2', children: _jsx(Button, { variant: 'outline-secondary', className: 'btn theme-btn theme-outline', onClick: function () { return loadMoreData(); }, children: _jsx(TeleScript, { line: telescript === null || telescript === void 0 ? void 0 : telescript.seeMoreLinkText, children: "See More" }) }) })) : null;
    };
    // Headers: Define your headers in an object
    // Rows: Add fields based on headers and the data
    var entriesTable = function (data) {
        var _a, _b, _c, _d, _e;
        var entries = data !== null && data !== void 0 ? data : [];
        var displayHeaders = {
            ticketNumber: (_a = telescript === null || telescript === void 0 ? void 0 : telescript.tableTicketNumber) !== null && _a !== void 0 ? _a : 'Ticket Number',
            gameName: (_b = telescript === null || telescript === void 0 ? void 0 : telescript.tableGameName) !== null && _b !== void 0 ? _b : 'Promotion/Reward',
            entryDate: (_c = telescript === null || telescript === void 0 ? void 0 : telescript.tableEntryDate) !== null && _c !== void 0 ? _c : 'Entry Date',
            award: (_d = telescript === null || telescript === void 0 ? void 0 : telescript.tableAward) !== null && _d !== void 0 ? _d : 'Award',
        };
        var displayRows = __spreadArray([], entries, true).map(function (row) {
            var _a, _b, _c;
            return (__assign(__assign({}, row), { fields: {
                    ticketNumber: (_a = row === null || row === void 0 ? void 0 : row.ticket_num) !== null && _a !== void 0 ? _a : '',
                    gameName: (_jsx(Link, { to: (row === null || row === void 0 ? void 0 : row.promotion_id) && String(row === null || row === void 0 ? void 0 : row.promotion_id).trim()
                            ? "/promotion?promotion=".concat(row === null || row === void 0 ? void 0 : row.promotion_id)
                            : (_b = options === null || options === void 0 ? void 0 : options.promotionsLink) !== null && _b !== void 0 ? _b : '/promotions', dangerouslySetInnerHTML: { __html: stripTags((_c = row === null || row === void 0 ? void 0 : row.promotion_name) !== null && _c !== void 0 ? _c : '') } })),
                    entryDate: formatDate === null || formatDate === void 0 ? void 0 : formatDate.dateTimeWithMeridiem(row === null || row === void 0 ? void 0 : row.created_at),
                    award: getCollectionRewardFromGamePlay(row, telescript === null || telescript === void 0 ? void 0 : telescript.itemText, telescript === null || telescript === void 0 ? void 0 : telescript.groupText),
                } }));
        });
        var displayOptions = {
            tableId: 'collections-history-table',
            isLoaded: pageLoaded,
            messageNoRows: (_e = telescript === null || telescript === void 0 ? void 0 : telescript.messageNoRows) !== null && _e !== void 0 ? _e : 'There are no collections.',
        };
        return (_jsxs(_Fragment, { children: [_jsx(TableDesktop, { headers: displayHeaders, rows: displayRows, options: displayOptions }), _jsx(TableMobile, { telescript: telescript, headers: displayHeaders, rows: displayRows, options: displayOptions })] }));
    };
    return (_jsxs(ContentBox, { variant: (_d = options === null || options === void 0 ? void 0 : options.variant) !== null && _d !== void 0 ? _d : 'theme-primary', id: hash, show: isHash(hash) ? 'true' : 'false', children: [_jsxs(ContentBoxHead, { children: [_jsx(TeleScript, { line: telescript === null || telescript === void 0 ? void 0 : telescript.title, children: "My Collections" }), (options === null || options === void 0 ? void 0 : options.hasCollapser) === true && (_jsx(ContentCollapser, { ariaLabel: headingPlainText(telescript === null || telescript === void 0 ? void 0 : telescript.title, 'My Collections'), upArrow: options.upArrow, downArrow: options.downArrow }))] }), _jsx(ContentBoxBody, { children: _jsx("div", { className: 'row', children: _jsxs("div", { className: 'col', children: [entriesTable(collections), loadMoreLink()] }) }) })] }));
};
export default MyCollectionsHistory;
